<template>
  <c-data-filters>
    <template #basic>
      <label class="sr-only">Search</label>

      <c-input type="text" :value="filters.search" @input="updateSearch">
        <i slot="prepend" class="fal fa-search" />
      </c-input>
    </template>

    <div class="row">
      <div class="col-lg-4 col-xl-6 mb-3">
        <div class="mb-3">
          <label>Search</label>

          <c-input type="text" :value="filters.search" @input="updateSearch">
            <i slot="prepend" class="fal fa-search" />
          </c-input>
        </div>
      </div>
      <div class="col-lg-4 col-xl-3 mb-3">
        <div class="mb-3">
          <label>Date range</label>
          <validation-provider name="date range" vid="date_range" rules="required" v-slot="{ failed }">
            <input-date-range
              v-model="dateRange"
              placeholder=""
              class="form-control date-range"
              :class="{ 'is-invalid': failed }"
            />
            <c-help-block />
          </validation-provider>
        </div>
      </div>
      <div class="col-lg-4 col-xl-3 mb-3">
        <div class="mb-3">
          <label>Status</label>

          <c-input
            as="multiselect"
            placeholder
            :options="statusOptions"
            :preselect-first="true"
            :show-labels="false"
            :allow-empty="false"
            label="name"
            v-model="status"
          />
        </div>
      </div>
    </div>
  </c-data-filters>
</template>

<script>
import { useQueryParamFilters } from '@codium/codium-vue'
import { debounce } from 'lodash'
import InputDateRange from '@/components/forms/InputDateRange'

export default {
  mixins: [useQueryParamFilters()],

  components: {
    InputDateRange
  },

  data () {
    return {
      filters: {
        search: null,
        status: 'all',
        sort: 'released_at',
        startDate: null,
        endDate: null,
        order: 'desc'
      },
      statusOptions: [
        { name: 'All', value: null },
        { name: 'Current', value: 'current' },
        { name: 'Testing', value: 'testing' },
        { name: 'Legacy', value: 'legacy' },
      ]
    }
  },

  computed: {
    status: {
      get () {
        return this.statusOptions.find(({ value }) => value === this.filters.status)
      },

      set ({ value }) {
        this.filters.status = value
      }
    },

    dateRange: {
      get () {
        return null
      },

      set (value) {
        if (value) {
          this.filters.startDate = value?.startDate ?? null
          this.filters.endDate = value?.endDate ?? null
        } else {
          this.filters.startDate = null
          this.filters.endDate = null
        }
      }
    },
  },

  methods: {
    updateSearch: debounce(function (value) {
      this.filters.search = value
    }, 500)
  }
}
</script>
